import { ServiceAndContactHero, ServiceAndContactPopularTopics, ServiceAndContactLinks, ServiceAndContactLinksBlock, ServiceAndContactUsps, ServiceAndContactContactOptions, } from './ServiceAndContact.js';
if (!customElements.get('zz-service-and-contact-hero')) {
    customElements.define('zz-service-and-contact-hero', ServiceAndContactHero);
}
if (!customElements.get('zz-service-and-contact-popular-topics')) {
    customElements.define('zz-service-and-contact-popular-topics', ServiceAndContactPopularTopics);
}
if (!customElements.get('zz-service-and-contact-links')) {
    customElements.define('zz-service-and-contact-links', ServiceAndContactLinks);
}
if (!customElements.get('zz-service-and-contact-links-block')) {
    customElements.define('zz-service-and-contact-links-block', ServiceAndContactLinksBlock);
}
if (!customElements.get('zz-service-and-contact-usps')) {
    customElements.define('zz-service-and-contact-usps', ServiceAndContactUsps);
}
if (!customElements.get('zz-service-and-contact-contact-options')) {
    customElements.define('zz-service-and-contact-contact-options', ServiceAndContactContactOptions);
}
